import { useLanguageStore } from '../store/languageStore'
import { translations } from '../translate'

export function useTranslation() {
  const { language } = useLanguageStore()
  const t = translations[language] || translations.ar

  const translate = (path: string): string => {
    const keys = path.split('.')
    let value: any = t
    
    for (const key of keys) {
      if (value && typeof value === 'object' && key in value) {
        value = value[key]
      } else {
        return path // Return path if translation not found
      }
    }
    
    return typeof value === 'string' ? value : path
  }

  return { t, translate, language }
}




